import {Module} from "vuex";
import {CurrencyState, ExchangeRateSnapshot, Program} from "@/store/CurrencyStore";
import {IDBase, QueryFacade} from "@/controller/QueryFacade";

export class AddressField {
    public address: string = "";
}

export class AddressFieldWithKeyColumn extends AddressField {
    public keyColumn: string = "";
}

export class AddressBlock implements IDBase {
    readonly id: string;
    addressFields: AddressField[] = [];


    constructor(id: string) {
        this.id = id;
    }
}

class AddressType<T> {
    addressBlock: AddressBlock;
    readonly fieldClazz: new() => T;

    constructor(id: string, fieldClazz: { new(): T}) {
        this.addressBlock = new AddressBlock(id);
        this.fieldClazz = fieldClazz;
    }
}


export class DeliveryAddressesState {
    CustomsAddress: AddressType<AddressField> = new AddressType("CustomsAddress", AddressField);
    CustomsClearance: AddressType<AddressField> = new AddressType("CustomsClearance", AddressField);
    ReceivingLocation: AddressType<AddressFieldWithKeyColumn> = new AddressType("ReceivingLocation", AddressFieldWithKeyColumn);
    Buyer: AddressType<AddressField> = new AddressType("Buyer", AddressField);
    DisponentRequester: AddressType<AddressField> = new AddressType("DisponentRequester", AddressField);
}


export class AddressStore implements Module<any, unknown> {
    public namespaced = true;
    public state: DeliveryAddressesState = new DeliveryAddressesState();

    public getters: { [func: string]: () => any } = {};

    public mutations = {
        addAddressField(state: DeliveryAddressesState, addressId: keyof DeliveryAddressesState) {
            state[addressId].addressBlock.addressFields.push(new state[addressId].fieldClazz());

        },
        persist(state: DeliveryAddressesState) {
            for (let key of Object.keys(state)) {
                QueryFacade.put("delivery_addresses", (<any>state)[key].addressBlock);
            }
        },

        async loadFromDb(state: DeliveryAddressesState) {
            const addressBlocks = await loadAddresses();
            for (let key of Object.keys(addressBlocks)) {
                (<any>addressStore).state[key] = addressBlocks[key as keyof DeliveryAddressesState];
            }
        }
    };

    constructor() {
        for (let key of Object.keys(this.state)) {
            this.getters[key] = () => {
                return (<any>this.state)[key];
            }
        }
    }
}

export const addressStore = new AddressStore();

export async function loadAddresses(): Promise<DeliveryAddressesState> {
    const res = new DeliveryAddressesState();
    for (let key in res) {
        const dbRes = await <AddressBlock><any>QueryFacade.get("delivery_addresses", key);
        if (dbRes) {
            res[key as keyof DeliveryAddressesState].addressBlock = dbRes;
        }
    }
    return res;
}